<template>
  <div>
    <div class="text-xs-center" style="padding-top: 25px; padding-bottom: 25px" v-if="loading">
      <div class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </div>
    <template v-else>
      <div style="margin-top: 10px;">
        <v-window v-model="step">
          <v-window-item :value="'parent'">
            <v-layout wrap>
              <v-flex xs12 sm6 md4 style="margin-bottom: 10px">
                <div>
                  <ul style="padding: 0;margin: 0; width: 80%">
                    <li
                      style="list-style-type: none; padding: 10px 0px;color: black;text-align: center;border-top-left-radius: 10px;border-top-right-radius: 10px;border: 1px solid #dddfe2;border-bottom: 0"
                    >
                      <div class="strong"><i class="fas fa-bars"></i></div>
                    </li>
                    <template v-if="persistent_menu.length > 0">
                      <li
                        v-for="(menu, index) in persistent_menu"
                        :key="'menu_' + index + '_' + menu.title"
                        style="position:relative;list-style-type: none;border: 1px solid #dddfe2; border-top: 1px solid #dddfe2;"
                        :class="{
                          'persistent-menu-bottom':
                            index == maxMenu - 1 || (!isEdit && index + 1 == persistent_menu.length)
                        }"
                      >
                        <add-button-persistent-menu
                          v-model="persistent_menu[index]"
                          @onDelete="deleteMenu(index)"
                          @onSelectNested="selectNestedMenu(index)"
                          :hasNested="true"
                          :onEdit="editing"
                        >
                          <template slot="append">
                            <v-list-tile
                              :disabled="index <= 0"
                              @click="onMoveButton(index, 'up', persistent_menu)"
                            >
                              <v-list-tile-title
                                :style="index <= 0 ? `color: lightgrey` : ''"
                                class="primary-color"
                                >{{ $t('Move up') }}</v-list-tile-title
                              >
                            </v-list-tile>
                            <v-list-tile
                              :disabled="index >= persistent_menu.length - 1"
                              @click="onMoveButton(index, 'down', persistent_menu)"
                            >
                              <v-list-tile-title
                                :style="
                                  index >= persistent_menu.length - 1 ? `color: lightgrey` : ''
                                "
                                class="primary-color"
                                >{{ $t('Move down') }}</v-list-tile-title
                              >
                            </v-list-tile>
                          </template>
                        </add-button-persistent-menu>

                        <!-- <a href="javascript:void(0);" style="width: 22px;margin-top: 8px;display: inline-block" v-if="menu.type == 'postback' && editing" @click="createSubMenu(index)"><span class="glyphicon glyphicon-plus"></span></a> -->
                        <div class="clearfix"></div>
                      </li>
                    </template>
                    <template v-else>
                      <li
                        style="position:relative;list-style-type: none;border: 1px solid #dddfe2; border-top: 1px solid #dddfe2;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;background: #eee"
                        v-if="!isEdit"
                      >
                        <div style="padding: 0px 10px">&nbsp;</div>

                        <!-- <a href="javascript:void(0);" style="width: 22px;margin-top: 8px;display: inline-block" v-if="menu.type == 'postback' && editing" @click="createSubMenu(index)"><span class="glyphicon glyphicon-plus"></span></a> -->
                        <div class="clearfix"></div>
                      </li>
                    </template>

                    <li
                      v-if="editing && persistent_menu.length < maxMenu"
                      style="list-style-type: none; border: 1px dashed #dddfe2; border-top: 0; padding: 10px 0px;overflow:auto;text-align: center;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;"
                    >
                      <a href="javascript:void(0);" @click="addMenu" class="primary-color">
                        <span class="fa fa-plus"></span>
                        {{ $t('Add menu') }}
                      </a>
                    </li>
                  </ul>
                </div>
              </v-flex>
            </v-layout>
          </v-window-item>
          <v-window-item :value="'nested'">
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <div class="col-sm-6 col-md-4">
                  <div
                    style="position:relative"
                    v-if="persistent_menu[current_sub_persistent_menu]"
                  >
                    <ul style="padding: 0;margin: 0; width: 80%">
                      <li
                        style="list-style-type: none; padding: 10px 0px;color: black;text-align: center;border-top-left-radius: 10px;border-top-right-radius: 10px;border: 1px solid #dddfe2;border-bottom: 1px solid #dddfe2;"
                      >
                        <div class="row" style="position:relative; margin-bottom: 0;">
                          <div
                            style="font-size: 22px; position: absolute;left: 19px;top: -5px"
                            @click="closeNestedMenu"
                          >
                            <span class="fas fa-chevron-left"></span>
                          </div>
                          <div v-if="current_sub_persistent_menu != null">
                            <div class="strong">
                              {{ persistent_menu[current_sub_persistent_menu].title }}
                            </div>
                          </div>
                          <div v-else>
                            <div class="strong">-</div>
                          </div>
                          <!-- <div class="col-xs-2" v-if="editing"><a href="javascript:void(0);" @click="deleteAllSubMenu"><span class="glyphicon glyphicon-trash"></span></a></div> -->
                        </div>
                      </li>
                      <template
                        v-if="
                          current_sub_persistent_menu != null &&
                            persistent_menu[current_sub_persistent_menu].type == 'nested'
                        "
                      >
                        <li
                          v-for="(menu, index) in persistent_menu[current_sub_persistent_menu]
                            .call_to_actions"
                          :key="'sub_menu_' + current_sub_persistent_menu + '_' + index"
                          style="position:relative;list-style-type: none;border: 1px solid #dddfe2; border-top: 0"
                          :class="{
                            'persistent-menu-bottom':
                              index == 4 ||
                              (!isEdit &&
                                index + 1 ==
                                  persistent_menu[current_sub_persistent_menu].call_to_actions
                                    .length)
                          }"
                        >
                          <add-button-persistent-menu
                            v-model="
                              persistent_menu[current_sub_persistent_menu].call_to_actions[index]
                            "
                            @onDelete="deleteSubMenu(index)"
                            :onEdit="editing"
                          ></add-button-persistent-menu>

                          <div class="clearfix"></div>
                        </li>
                      </template>
                      <li
                        v-if="editing"
                        style="list-style-type: none; border: 1px dashed #dddfe2; border-top: 0; padding: 10px 0px;overflow:auto;text-align: center;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;"
                      >
                        <a href="javascript:void(0);" @click="addSubMenu" class="primary-color">
                          <i class="fa fa-plus"></i>
                          {{ $t('Add Submenu') }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-window-item>
        </v-window>
      </div>

      <div class="clearfix"></div>

      <span class="small" v-if="isError" style="color: red">{{
        $t('The persistent Submenu can not be empty')
      }}</span>
      <span class="small" v-if="isTimeout" style="color: red"
        >Please try again 10 minutes later</span
      >

      <div class="text-xs-center">
        <template v-if="editing">
          <slot name="footer" :cancelEdit="cancelEdit" :savePersistentMenu="savePersistentMenu">
            <v-btn outline color="grey" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" @click="savePersistentMenu">{{ $t('Save') }}</v-btn>
          </slot>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import AddButtonPersistentMenu from './AddButtonPersistentMenu'

export default {
  props: {
    value: { deafult: undefined },
    isEdit: {
      default: false
    },
    defaultPersistent: {
      default: false
    }
  },
  data: function() {
    return {
      persistent_menu: [],
      sub_persistent_menu: [],
      current_sub_persistent_menu: null,
      isError: false,
      isTimeout: false,
      loading: true,
      step: 'parent',
      maxMenu: 20
    }
  },
  components: {
    AddButtonPersistentMenu
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    editing: function() {
      return this.isEdit
    }
  },
  async created() {
    this.formatPersistent(this.value)
  },
  methods: {
    formatPersistent(persistent) {
      this.loading = true

      if (this.defaultPersistent) {
        this.persistent_menu = [
          {
            type: 'postback',
            title: 'เมนูหลัก',
            payload: 'เมนูหลัก'
          }
        ]
        this.cached_persistent_menu = JSON.stringify(this.persistent_menu)
        this.loading = false
      } else {
        this.persistent_menu = []
        try {
          if (persistent == false) this.persistent_menu = persistent
          else {
            this.persistent_menu = persistent.map(val => {
              val['call_to_actions'] = []
              if (val.type == 'nested') {
                val.call_to_actions = val.call_to_actions.map(sub_val => {
                  return Object.assign({}, sub_val)
                })
              }
              return val
            })
          }
        } catch (error) {
          console.log(error)
        }
        this.cached_persistent_menu = JSON.stringify(this.persistent_menu)

        this.loading = false
      }
    },
    updatePersistentToLocalStorage(persistents) {},
    onMoveButton: function(index, direction, item) {
      var vm = this

      if (direction == 'up') {
        this.persistent_menu.splice(index, 0, this.persistent_menu.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        this.persistent_menu.splice(index, 0, this.persistent_menu.splice(index + 1, 1)[0])
      }

      // vm.$emit('input', vm.bubbleMessages)
    },
    async getPersistentMenu() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.selectedBot.pageid,
          status: vm.selectedBot.status,
          access_token: vm.selectedBot.page_access_token
        }

        api.getPersistentMenu(data, function(error, response) {
          if (error) {
            reject(error)
            return
          }

          if (response.data && response.data[0] == null) {
            resolve(false)
          } else if (
            response.data &&
            response.data[0] &&
            response.data[0].persistent_menu &&
            response.data[0].persistent_menu[0] &&
            response.data[0].persistent_menu[0].call_to_actions
          ) {
            resolve(response.data[0].persistent_menu[0].call_to_actions)
          } else {
            resolve([])
          }
        })
      })
    },
    savePersistentMenu: function() {
      // if (this.isTimeout) {
      //     return false
      // }
      var vm = this
      var data = {
        persistent_menu: [
          {
            locale: 'default',
            composer_input_disabled: false,
            call_to_actions: []
          }
        ]
      }

      vm.isError = false
      if (vm.persistent_menu) {
        $.each(vm.persistent_menu, function(index, menu) {
          if (menu.title === '' || menu.title == null) {
            vm.isError = true
          }

          if (menu.type === 'postback') {
            data.persistent_menu[0].call_to_actions.push({
              title: menu.title,
              type: 'postback',
              payload: menu.payload
            })
          } else if (menu.type === 'web_url') {
            var link = {
              title: menu.title,
              type: 'web_url',
              url: menu.url,
              webview_height_ratio: menu.webview_height_ratio
            }
            if (menu.url.includes('api-sme-prod.zwiz.app')) {
              link.messenger_extensions = true
            }
            data.persistent_menu[0].call_to_actions.push(link)
          } else if (menu.type === 'nested') {
            var nested = []
            $.each(menu.call_to_actions, function(sindex, sub_menu) {
              if (sub_menu.title === '' || sub_menu.title == null) {
                vm.isError = true
              }
              if (sub_menu.type === 'postback') {
                nested.push({
                  title: sub_menu.title,
                  type: 'postback',
                  payload: sub_menu.payload
                })
              } else if (sub_menu.type === 'web_url') {
                var link = {
                  title: sub_menu.title,
                  type: 'web_url',
                  url: sub_menu.url,
                  webview_height_ratio: sub_menu.webview_height_ratio
                }
                if (sub_menu.url.includes('api-sme-prod.zwiz.app')) {
                  link.messenger_extensions = true
                }
                nested.push(link)
              }
            })
            if (menu.call_to_actions.length === 0) {
              vm.isError = true
            }
            data.persistent_menu[0].call_to_actions.push({
              title: menu.title,
              type: 'nested',
              call_to_actions: nested
            })
          }
        })
      }

      if (vm.isError) {
        return false
      }

      data.pageid = vm.selectedBot.pageid
      data.status = vm.selectedBot.status
      data.access_token = vm.selectedBot.page_access_token

      vm.loading = true
      api.editPersistentMenu(data, function(error, response) {
        if (error) {
          console.error(error)

          vm.loading = false
          return
        }

        response = response.data
        vm.cached_persistent_menu = JSON.stringify(vm.persistent_menu)
        vm.$nextTick(function() {
          vm.$emit('onSave')
          vm.isError = false
          vm.isTimeout = false

          vm.loading = false
          vm.$forceUpdate()
        })
      })
    },
    cancelEdit: function() {
      var vm = this
      vm.step = 'parent'
      vm.$nextTick(function() {
        vm.current_sub_persistent_menu = null
        vm.persistent_menu = []
        vm.persistent_menu = JSON.parse(vm.cached_persistent_menu)
        vm.$nextTick(function() {
          vm.$emit('onSave')
          vm.isError = false
          vm.isTimeout = false
          vm.$forceUpdate()
        })
      })
    },
    createSubMenu: function(index) {
      this.persistent_menu[index].type = 'nested'
      this.persistent_menu[index]['call_to_actions'] = [
        {
          title: '',
          type: 'postback',
          payload: '',
          isShow: true
        }
      ]
      this.current_sub_persistent_menu = index
    },
    addMenu: function() {
      if (this.persistent_menu.length < this.maxMenu) {
        this.persistent_menu.push({
          title: '',
          type: 'postback',
          payload: '',
          isShow: true
        })
      }
    },
    addSubMenu: function() {
      // console.log(this.persistent_menu[this.current_sub_persistent_menu]['call_to_actions'].length)
      if (this.persistent_menu[this.current_sub_persistent_menu]['call_to_actions'].length < 5) {
        var menu = this.persistent_menu[this.current_sub_persistent_menu]['call_to_actions']

        menu.push({
          title: '',
          type: 'postback',
          payload: '',
          isShow: true
        })

        this.$set(this.persistent_menu[this.current_sub_persistent_menu], 'call_to_actions', menu)
        this.$forceUpdate()
      }
    },
    deleteMenu: function(index) {
      this.persistent_menu.splice(index, 1)
    },
    deleteSubMenu: function(index) {
      this.persistent_menu[this.current_sub_persistent_menu].call_to_actions.splice(index, 1)
      this.$forceUpdate()
    },
    deleteAllSubMenu: function() {
      if (this.persistent_menu[this.current_sub_persistent_menu]) {
        this.persistent_menu[this.current_sub_persistent_menu].type = 'postback'
        this.persistent_menu[this.current_sub_persistent_menu].payload = this.persistent_menu[
          this.current_sub_persistent_menu
        ].title
        delete this.persistent_menu[this.current_sub_persistent_menu].call_to_actions
      }
    },
    selectNestedMenu: function(index) {
      var vm = this
      vm.current_sub_persistent_menu = index
      setTimeout(() => {
        vm.$nextTick(function() {
          vm.step = 'nested'
        })
      }, 500)
    },
    closeNestedMenu: function() {
      var vm = this
      vm.step = 'parent'
      setTimeout(() => {
        vm.$nextTick(function() {
          vm.current_sub_persistent_menu = null
        })
      }, 500)
    }
  },
  watch: {
    value: function() {
      var vm = this
      vm.persistent_menu = []
      $.each(vm.value, function(index, val) {
        vm.persistent_menu.push(Object.assign({}, val))
        if (val.type == 'nested') {
          vm.persistent_menu[index].call_to_actions = []
          $.each(val.call_to_actions, function(sindex, sub_val) {
            vm.persistent_menu[index].call_to_actions.push(Object.assign({}, sub_val))
          })
        }
      })
      vm.cached_persistent_menu = JSON.stringify(vm.persistent_menu)
    }
  }
}
</script>

<style scoped>
.persistent-menu-bottom {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/setting/PersistentMenu.vue